import env from '@config/env';

/* eslint-disable no-console */
const logger = {
  info: (message: unknown, ...args: unknown[]) => {
    if (env.DEV) console.info(`INFO:`, message, ...args);
  },
  error: (message: unknown, ...args: unknown[]) => {
    if (env.DEV) console.error(`ERROR:`, message, ...args);
  },
  warn: (message: unknown, ...args: unknown[]) => {
    if (env.DEV) console.warn(`WARN:`, message, ...args);
  },
  debug: (message: unknown, ...args: unknown[]) => {
    if (env.DEV) console.debug(`DEBUG:`, message, ...args);
  },
  log: (message: unknown, ...args: unknown[]) => {
    if (env.DEV) console.log(`LOG:`, message, ...args);
  },
};

export default logger;
